import React, { useState, useEffect } from "react";
import Progress from "../../../components/progress/progress";
// @ts-ignore
import Cookies from "js-cookie";
import { useForm, FieldErrors } from "react-hook-form";
import { sendShahkar } from "../../../services/auth/shahkar/shahkar";
import { useMutation } from "@tanstack/react-query";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toastOptions } from "../../../features/toast/toast";
import Step from "../../../features/step/step";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../features/routes/route";
import {
    Picker,
    format,
    newDate,
    DatePickerConfig,
} from "@persian-tools/persian-mobile-datepicker";
import DatePicker from "@amir04lm26/react-modern-calendar-date-picker";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import Loading from "../../../components/loading/loading";
import { matchCart } from "../../../services/auth/cart/matchCart";
import { SetUser } from "../../../services/auth/userInfo/setUser";
import { ConvertCts } from "../../../services/auth/cart/Convert";

const config: DatePickerConfig = {
    year: { caption: { text: "سال" } },
    month: { caption: { text: "ماه" } },
    day: { caption: { text: "روز" } },
};

const FirstStep = () => {
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        formState: { errors },
    } = useForm<any>({
        defaultValues: {
            mobileNumber: Cookies.get("mobileNumber") || "",
            nationalCode: Cookies.get("nationalCode") || "",
            IRTName: Cookies.get("IRTName") || "",
            refral: Cookies.get("refNum") || "",
            refralName: Cookies.get("refName") || "",
            birthDay: Cookies.get("birthDay") || "",
        },
    });

    const navigate = useNavigate();
    const mutation = useMutation({
        mutationFn: sendShahkar,
        onSuccess: (data) => {
            let Newdata: any = {
                number: Cookies.get('number'),
                phoneNumber: Cookies.get('mobileNumber'),
                referralUserPhoneNumber: Cookies.get("refNum_new"),
            }
            ConvertMutation.mutate(Newdata);
        },
        onError: (error: any) => {
            toast.error(error?.response?.data?.message, toastOptions);
        },
    });

    const onSubmit = (data: any) => {
        if (data?.birthDay !== "") {
            setBirthError(false)
            let newData = data;
            Cookies.set("mobileNumber", data.mobileNumber);
            Cookies.set("birthDay", data.birthDay);
            if (newData.number && Array.isArray(newData.number)) {
                newData.number =
                    newData.number[4] + newData.number[3] + newData.number[2] + newData.number[1];
                Cookies.set("number", newData.number);
            }
            Cookies.set('IRTName', data.IRTName);
            Cookies.set('refNum_new', newData.refral ? newData.refral : Cookies.get("refNum") || "");
            delete newData.refral;
            delete newData.number;
            Cookies.set("nationalCode", newData.nationalCode);
            mutation.mutate(newData);
        }
        else {
            setBirthError(true)
            toast.error("فیلد تاریخ تولد الزامی است", toastOptions);
        }
    };

    const onError = (errors: FieldErrors<any>) => {
        const uniqueErrorMessages = new Set<string>();
        Object.values(errors).forEach((error) => {
            if (error?.message) {
                uniqueErrorMessages.add(error.message as string);
            }
        });
        if (errors?.birthDay) {
            toast.error("یکی از فیلدای تاریخ تولد رو فراموش کردی", toastOptions);
        }
        if (errors?.number) {
            toast.error("یکی از فیلدای شماره کارت رو فراموش کردی", toastOptions);
        }
        uniqueErrorMessages.forEach((message) => {
            toast.error(message, toastOptions);
        });
    };

    const [showPicker, setShowPicker] = useState(false);
    const [selectedDateValue, setSelectedDateValue] = useState<string | undefined>(undefined);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
    const [birthError, setBirthError] = useState(false);

    const [selectedPcDate, setSelectedPcDate] = useState<{
        year: number;
        month: number;
        day: number;
    } | null>(null);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1024);
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        const birthDayValue = watch("birthDay");
        if (birthDayValue) {
            const parts = birthDayValue.split("/");
            if (parts.length === 3) {
                setSelectedPcDate({
                    year: parseInt(parts[0], 10),
                    month: parseInt(parts[1], 10),
                    day: parseInt(parts[2], 10),
                });
                setSelectedDateValue(birthDayValue);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watch("birthDay")]);

    const handleMobileSubmit = (selectedDate: any) => {
        if (!selectedDate || !selectedDate.date) return;
        const date = format(selectedDate.date, "yyyy/MM/dd");
        setSelectedDateValue(date);
        setValue("birthDay", date, { shouldValidate: true });
    };

    const handleMobileClose = () => {
        setShowPicker(false);
    };

    const handlePcDateChange = (date: any) => {
        if (date) {
            const formattedDate = `${date.year}/${String(date.month).padStart(2, "0")}/${String(
                date.day
            ).padStart(2, "0")}`;
            setSelectedPcDate(date);
            setSelectedDateValue(formattedDate);
            setValue("birthDay", formattedDate, { shouldValidate: true });
        }
    };
    const validateNationalCode = (value: any) => {
        if (!/^\d{10}$/.test(value)) {
            return 'کد ملی باید ده رقم باشد';
        }

        const check = +value[9];
        const sum = [...value].slice(0, 9)
            .map((num, index) => +num * (10 - index))
            .reduce((a, b) => a + b, 0);

        const remainder = sum % 11;

        if ((remainder < 2 && check === remainder) || (remainder >= 2 && check === 11 - remainder)) {
            return true;
        }

        return 'کد ملی معتبر نیست';
    };
    const ConvertMutation = useMutation({
        mutationFn: ConvertCts,
        onSuccess: data => {
            Cookies.set('firstNameUser', data?.firstName)
            Cookies.set('lastNameUser', data?.lastName)
            Cookies.set('name', data.lastName ? data.firstName + ' ' + data.lastName : data.firstName + ' ' + data.lastName);
            localStorage.setItem('name', data.lastName ? data.firstName + ' ' + data.lastName : data.firstName + ' ' + data.lastName)
            Cookies.set('iban', data?.iban)
            Cookies.set('bankName', data?.bankName)
            Cookies.set('depositNumber', data?.depositNumber)
            if (data?.fullname == null && Cookies.get('refNum_new')) {
                toast.error('شماره معرف واردشده در سیستم ما ثبت نشده است', toastOptions)
            }
            else {
                let newData: any = {
                    phoneNumber: Cookies.get('mobileNumber'),
                    iban: data?.iban,
                    birthDate: Cookies.get('birthDay'),
                    nationalCode: Cookies.get('nationalCode'),
                }
                Cookies.set('refName_new', data?.fullname);
                MatchMutation.mutate(newData)
            }
        },
        onError: (data: any) => {
            toast.error(data?.response?.data?.message, toastOptions);
        }
    });
    const UserMutation = useMutation({
        mutationFn: SetUser,
        onSuccess: data => {
            Cookies.set('user', data)
            navigate(routes.auth[2].address);
        },
        onError: (data: any) => {
            toast.error(data?.response?.data?.message, toastOptions);
        }
    });
    const MatchMutation = useMutation({
        mutationFn: matchCart,
        onSuccess: data => {
            let birth = Cookies.get('birthDay');
            const cleanedDate = birth.replace(/\//g, "");
            let newData: any = {
                nationalCode: Cookies.get('nationalCode'),
                birthDate: cleanedDate,
                phoneNumber: Cookies.get('mobileNumber'),
            }
            UserMutation.mutate(newData)
        },
        onError: (data: any) => {
            toast.error(data?.response?.data?.message, toastOptions);
        }
    });
    return (
        <>
            {UserMutation.isPending ? (
                <div
                    style={{ height: "100dvh" }}
                    className="d-flex h-100 align-items-center justify-content-center"
                >
                    <Loading />
                </div>
            ) : (
                <>
                    <Progress number={1} />
                    <section className="container pb-3">
                        <div className="row justify-content-center overflow-x-hidden">
                            <div className="col-lg-5 col-md-7 col-12">
                                <form onSubmit={handleSubmit(onSubmit, onError)}>
                                    <h1 className="h2 fw-bold text-white text-center">پیش ثبت‌نام</h1>
                                    <fieldset className="mt-md-5 mt-4">
                                        <label className="form-label text-white mb-3">
                                            شماره موبایلتون رو قبلا گفتین
                                        </label>
                                        <input
                                            maxLength={11}
                                            type="tel"
                                            id="telephone"
                                            className={`form-control blue-bg ${errors.mobileNumber ? 'border border-danger border-3' : ''}`}
                                            {...register("mobileNumber", {
                                                required: "شماره موبایل الزامی است",
                                                validate: (val: string) => {
                                                    const fullMobile = val.startsWith("09") ? val : "09" + val;
                                                    if (!/^09\d{9}$/.test(fullMobile)) return "شماره موبایل معتبر نیست";
                                                    return true;
                                                },
                                                maxLength: {
                                                    value: 11,
                                                    message: "شماره موبایل نباید بیشتر از 11 رقم باشد"
                                                },
                                            })}
                                        />
                                    </fieldset>
                                    <fieldset className="mt-3">
                                        <label className="form-label text-white mb-3">
                                            کد ملی‌تون رو بنویسین
                                        </label>
                                        <input
                                            maxLength={10}
                                            id="code"
                                            type="tel"
                                            className={`form-control ${errors.nationalCode ? 'border border-danger border-3' : ''}`}
                                            {...register("nationalCode", {
                                                required: "فیلد کد ملی الزامی است",
                                                validate: validateNationalCode,
                                            })}
                                        />
                                    </fieldset>
                                    <fieldset className="mt-3">
                                        <label className="form-label text-white mb-3">
                                            اسم کسب و کارتون رو بنویسین
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register("IRTName", {
                                                required: false,
                                            })}
                                        />
                                    </fieldset>
                                    <div className="row mt-3">
                                        <label className="form-label text-white mb-3">
                                            شماره کارتتون رو وارد کنین
                                        </label>
                                        {Array.from({ length: 4 }, (_, index) => (
                                            <fieldset key={index} className="col-3">
                                                <input
                                                    type="tel"
                                                    maxLength={4}
                                                    id={`digit${index}`}
                                                    disabled={index < 3}
                                                    className={`form-control step-input ltr ${errors.number ? 'border border-danger border-3' : ''}`}
                                                    onKeyDown={(e) => Step(e, index, `digit`)}
                                                    {...register(`number.${index + 1}`, {
                                                        required: "یکی از فیلدای شماره کارت رو فراموش کردی",
                                                    })}
                                                />
                                            </fieldset>
                                        ))}
                                    </div>
                                    <fieldset className="mt-3">
                                        <label className="form-label text-white mb-3">
                                            تاریخ تولدتون رو وارد کنین
                                        </label>
                                        <div style={{ position: "relative" }}>
                                            {isMobile ? (
                                                <>
                                                    <input
                                                        type="text"
                                                        defaultValue={selectedDateValue}
                                                        onClick={() => setShowPicker(true)}
                                                        readOnly
                                                        className={`form-control ${errors.birthDay ? 'border border-danger border-3' : ''}`}
                                                        placeholder="انتخاب تاریخ تولد"
                                                        {...register("birthDay", {
                                                            required: "تاریخ تولد الزامی است",
                                                        })}
                                                    />
                                                    {showPicker && (
                                                        <div className="d-flex justify-content-center">
                                                            <Picker
                                                                isOpen={showPicker}
                                                                config={config}
                                                                minDate={newDate({
                                                                    year: 1330,
                                                                    month: 1,
                                                                    day: 1,
                                                                })}
                                                                maxDate={newDate({
                                                                    year: 1410,
                                                                    month: 12,
                                                                    day: 30,
                                                                })}
                                                                onChange={handleMobileSubmit}
                                                                onSubmit={() => {
                                                                    setShowPicker(false);
                                                                }}
                                                                onClose={handleMobileClose}
                                                                highlightWeekends
                                                            />
                                                        </div>
                                                    )}
                                                </>
                                            ) : (
                                                <DatePicker
                                                    value={selectedPcDate}
                                                    onChange={handlePcDateChange}
                                                    inputPlaceholder="انتخاب تاریخ تولد"
                                                    inputClassName={`form-control w-100 ${birthError ? 'border border-danger border-3' : ''}`}
                                                    shouldHighlightWeekends
                                                    locale="fa"
                                                    minimumDate={{ year: 1330, month: 1, day: 1 }}
                                                    maximumDate={{ year: 1410, month: 12, day: 30 }}
                                                />
                                            )}
                                        </div>
                                    </fieldset>
                                    <fieldset className="mt-3">
                                        <label className="form-label text-white mb-3">
                                            {!!Cookies.get("refNum") ? (
                                                <>
                                                    نام معرف
                                                </>
                                            ) : (
                                                <>
                                                    اگه کسی ایران‌تراکنش رو بهتون معرفی کرده شمارشو اینجا وارد کنین
                                                </>
                                            )}
                                        </label>
                                        {!!Cookies.get("refNum") ? (
                                            <>
                                                <input
                                                    type="text"
                                                    id="refral"
                                                    maxLength={11}
                                                    readOnly={!!Cookies.get("refName")}
                                                    className={`form-control ${errors.refral ? 'border border-danger border-3' : ''}`}
                                                    {...register("refralName", {
                                                        required: "نام معرف الزامی است",
                                                    })}
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <input
                                                    type="tel"
                                                    id="refral"
                                                    maxLength={11}
                                                    readOnly={!!Cookies.get("refNum")}
                                                    className={`form-control ${errors.refral ? 'border border-danger border-3' : ''}`}
                                                    {...register("refral", {
                                                        validate: (val: string) => {
                                                            if (!val) return true;
                                                            if (!/^09\d{9}$/.test(val)) return "شماره معرف اشتباه است";
                                                            return true;
                                                        },
                                                    })}
                                                />
                                            </>
                                        )}

                                    </fieldset>
                                    <div className="d-flex justify-content-end mt-3">
                                        <button
                                            type="submit"
                                            disabled={mutation.isPending}
                                            className="btn form-btn fw-bold rounded rounded-pill p-2 px-4"
                                        >
                                            {mutation.isPending ? (
                                                <>
                                                    در حال ارسال
                                                    <span className="spinner-border spinner-border-sm ms-2"></span>
                                                </>
                                            ) : (
                                                <>
                                                    ادامه
                                                    <svg
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M12.7801 6.31005C15.6501 4.66005 18.0001 6.01005 18.0001 9.33005V12V14.67C18.0001 17.98 15.6501 19.34 12.7801 17.68L10.4701 16.34L8.16007 15C5.29007 13.34 5.29007 10.63 8.16007 8.97005"
                                                            stroke="#171717"
                                                            strokeWidth="2"
                                                            strokeMiterlimit="10"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                </>
            )
            }
            <ToastContainer />
        </>
    );
};

export default FirstStep;
